import React from 'react';
import { BlueCircle, UpgradeMessageContainer as StyledContainer, TurquoiseCircle, YellowCircle } from './styles';

type Props = {
	children: React.ReactNode;
	hasArrow?: boolean;
	isWidget?: boolean;
};

export const UpgradeMessageContainer = ({ children, isWidget = false, hasArrow }: Props) => (
	<StyledContainer $isWidget={isWidget} $hasArrow={hasArrow}>
		<YellowCircle />
		<TurquoiseCircle />
		<BlueCircle />
		{children}
	</StyledContainer>
);
